import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

import Arranger from '~c/components/base/arranger';
import { Checkbox } from '~c/components/base/checkbox';
import { spc } from '~c/components/base/spacer';
import Text from '~c/components/base/text';

interface Props {
  className?: string;
}

const CheckboxNogroupDemo: React.FC<Props> = ({ className }) => {
  const [check1, setCheck1] = React.useState(false);
  const [check2, setCheck2] = React.useState(false);

  return (
    <Arranger
      className={className}
      direction="column"
      sx={{ pl: spc.between_horizontal_s }}
    >
      <Text>Without CheckboxGroup</Text>
      <Checkbox
        label="Check 1"
        checked={check1}
        onChange={(evt, checked) => setCheck1(checked)}
      />
      <Checkbox
        label="Check 2"
        checked={check2}
        onChange={(evt, checked) => setCheck2(checked)}
      />
    </Arranger>
  );
};

export default muiStyled(CheckboxNogroupDemo)(({ theme }) => css``);
